/**
 * Sidebar genişliği hem Sidebar hem Navbar tarafından kullanılıyor
 * (navbar kendi genişliğini `100% - DRAWER_WIDTH` olarak hesaplıyor).
 * İki dosyada ayrı ayrı tanımlıydı; biri değişince diğeri kaymıştı.
 */
export const DRAWER_WIDTH = 240;
